import Card from 'react-bootstrap/Card';
import { Form as BSForm, Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { EducationQualificationForm } from './educationQualificationFragment';
import { HseForm } from './hseFragment';
import { HighSchoolForm } from './highSchoolFragment';
import { OtherCertificatesForm } from './otherCertificatesFragment';
import SigniteButton from '../../../../ui-elements/signite-button/signiteButton';
import JSONPretty from 'react-json-pretty';
import { CandidateEducationDetailsValidationSchema } from '../../validations/educationDetailsValidationSchema';
import { reverseTransformEducationDetails } from '../../transformers/educationDetailsTransformer';
import { useState } from 'react';
import { useRef } from 'react';
import { CandidateService } from '../../../../../services/candidateService';
import Loader from 'react-spinner-loader';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CandidateEducationDetailsForm = ({ componentRef, onSubmit, educationDetails, saveCurrentValues }) => {
  const educationalDocFile = useRef(null);
  const patentFile = useRef(null);
  const initialValues = {
    educationalDocs: [],
    assessmentFiles: [],
    hseSchoolName: '',
    hseStartDate: null,
    hseEndDate: null,
    hseCGPA: '',
    highSchoolSchoolName: '',
    highSchoolStartDate: null,
    highSchoolEndDate: null,
    highSchoolCGPA: '',
    otherCertificates: [],
    educationalDocs: [],
    assessmentFiles: [],
    doctorates: [
      {
        doctorateUniversityOrCollegeName: '',
        doctorateCourseType: '',
        doctorateSpecialization: '',
        doctorateUniversityOrCollegeStartDate: null,
        doctorateUniversityOrCollegeEndDate: null,
      },
    ],

    graduationLst: [
      {
        graduationUniversityOrCollegeName: '',
        graduationCourseType: '',
        graduationDegree: '',
        graduationSpecialization: '',
        graduationUniversityOrCollegeStartDate: null,
        graduationUniversityOrCollegeEndDate: null,
        graduationCGPA: null,
        graduationBacklogStartDate: null,
        graduationBacklogEndDate: null,
        graduationBacklogReason: '',
      },
    ],
    pgLst: [
      {
        pgUniversityOrCollegeName: '',
        pgCourseType: '',
        pgDegree: '',
        pgSpecialization: '',
        pgUniversityOrCollegeStartDate: null,
        pgUniversityOrCollegeEndDate: null,
        pgCGPA: null,
        pgBacklogStartDate: null,
        pgBacklogEndDate: null,
        pgBacklogReason: '',
      },
    ],

    highSchoolBacklogStartDate: null,
    highSchoolBacklogEndDate: null,
    highSchoolBacklogReason: '',
    hseBacklogStartDate: null,
    hseBacklogEndDate: null,
    hseBacklogReason: '',
  };
  let educationData;
  try {
    educationData = educationDetails && reverseTransformEducationDetails(educationDetails.educationalDetails);
  } catch (e) {
    console.log(e);
  }

  const handleDownload = (fileType, filePath, originalName) => {
    const ext = originalName.split('.').pop().toLowerCase();
    const knownExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];
    const fileName = knownExtensions.includes(ext) ? originalName : `${originalName}.pdf`;

    CandidateService.downloadFile(fileType, filePath)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };



  return (
    <Formik
      initialValues={educationData || initialValues}
      isInitialValid={false}
      onSubmit={async (data) => {
        onSubmit(data, 'educational-details');
      }}
      validationSchema={CandidateEducationDetailsValidationSchema}
      innerRef={componentRef}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
        const [loader, setLoader] = useState(false);
        const removeFile = (field, indexToRemove) => {
          console.log(field, indexToRemove);
          if (indexToRemove >= 0) {
            let eduDocs = _.get(values, field);
            console.log(eduDocs);
            eduDocs = _.filter(eduDocs, (_, index) => index !== indexToRemove);
            setFieldValue(field, eduDocs);
          }
          //setFieldValue(field, null);
        };
        const eduFileUploadHandler = (data) => {
          let educationalDocs = (values.educationalDocs && [...values.educationalDocs]) || [];

          educationalDocs.push({ path: data.path, originalName: data.originalName });
          console.log(educationalDocs);
          setFieldValue(`educationalDocs`, educationalDocs);
        };

        const patentFileUploadHandler = (data) => {
          let patentDocs = (values.assessmentFiles && [...values.assessmentFiles]) || [];
          console.log(patentDocs);
          patentDocs.push({ path: data.path, originalName: data.originalName });
          setFieldValue(`assessmentFiles`, patentDocs);
        };
        const handleFileChange = (event) => {
          if (event.target.files[0]) {
            console.log('File selection captured!', event.target.files[0]);
            const formData = new FormData();
            formData.append('file', event.target.files[0]);
            switch (event.target.id) {
              case 'EDUCATIONAL':
                CandidateService.uploadFile(formData, event.target.id, eduFileUploadHandler, setLoader);
                break;
              case 'ASSESSMENTS':
                CandidateService.uploadFile(formData, event.target.id, patentFileUploadHandler, setLoader);
                break;
              default:
                console.error('Invalid document upload.');
            }
          }
        };

        saveCurrentValues(values);

        return (
          <>
            <Form className="signite-form">
              <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
              {window.debug && window.debug == true && (
                <Card className="mb-3">
                  <Card.Title>DEBUG</Card.Title>
                  <Card.Body className="side-pad-24">
                    <JSONPretty data={values}></JSONPretty>
                    <JSONPretty data={errors}></JSONPretty>
                    <JSONPretty data={touched}></JSONPretty>
                  </Card.Body>
                </Card>
              )}
              <Card>
                <Card.Title>Education Qualification</Card.Title>
                <Card.Body className="side-pad-24">
                  <EducationQualificationForm
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    initialized={educationData != null}
                  ></EducationQualificationForm>
                </Card.Body>
                <Card.Title>12th Standard</Card.Title>
                <Card.Body className="side-pad-24">
                  <HseForm
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    initialized={educationData != null}
                  ></HseForm>
                </Card.Body>
                <Card.Title>10th Standard</Card.Title>
                <Card.Body className="side-pad-24">
                  <HighSchoolForm
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    initialized={educationData != null}
                  ></HighSchoolForm>
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 24 }}>
                <Card.Title>Other Certificates</Card.Title>
                <Card.Body className="side-pad-24">
                  <OtherCertificatesForm
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    initialized={educationData != null}
                  />
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 24 }}>
                <Card.Title>Provision To Store Documents</Card.Title>
                <Card.Body className="side-pad-24">
                  <Row style={{ paddingLeft: 20 }}>
                    <div className="file-upload d-flex align-items-center mb-3">
                      <BSForm.Group as={Col} controlId={'fileUpload'}>
                        <SigniteButton
                          variant="primary"
                          className="signiteUploadButton"
                          onClick={() => educationalDocFile.current.click()}
                        >
                          Browse..
                        </SigniteButton>
                        <input
                          type="file"
                          id="EDUCATIONAL"
                          ref={educationalDocFile}
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                          accept=".doc,.docx,.pdf"
                        />
                        <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
                          {(_.get(values, `educationalDocs`) &&
                            _.get(values, `educationalDocs`).map((eduDoc, index) => (
                              <span key={index}>
                                <a
                                  style={{ cursor: 'pointer', color: '#eb4b15' }}
                                  onClick={() =>
                                    handleDownload(
                                      "EDUCATIONAL",
                                      _.get(eduDoc, `path`),
                                      _.get(eduDoc, `originalName`)
                                    )
                                  }
                                >
                                  {_.get(eduDoc, `originalName`)}
                                </a>
                                <a
                                  onClick={() => removeFile(`educationalDocs`, index)}
                                  style={{ marginRight: 5, marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                                >
                                  <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                                </a>
                                {index < _.get(values, `educationalDocs`).length - 1 ? ',' : ''}
                              </span>
                            ))) || `Or drop file here`}
                        </BSForm.Label>
                      </BSForm.Group>
                    </div>
                  </Row>
                </Card.Body>
              </Card>

              <Card style={{ marginTop: 24 }}>
                <Card.Title>DISC Assessment Report</Card.Title>
                <Card.Body className="side-pad-24">
                  <Row style={{ paddingLeft: 20 }}>
                    <div className="file-upload d-flex align-items-center mb-3">
                      <BSForm.Group as={Col} controlId={'fileUpload'}>
                        <SigniteButton
                          variant="primary"
                          className="signiteUploadButton"
                          onClick={() => patentFile.current.click()}
                        >
                          Browse..
                        </SigniteButton>
                        <input
                          type="file"
                          id="ASSESSMENTS"
                          ref={patentFile}
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                          accept=".doc,.docx,.pdf"
                        />
                        <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
                          {(_.get(values, `assessmentFiles`) &&
                            _.get(values, `assessmentFiles`).map((assessDoc, index) => (
                              <span key={index}>
                                <a
                                  style={{ cursor: 'pointer', color: '#eb4b15' }}
                                  onClick={() =>
                                    handleDownload(
                                      "ASSESSMENTS",
                                      _.get(assessDoc, `path`),
                                      _.get(assessDoc, `originalName`)
                                    )
                                  }
                                >
                                  {_.get(assessDoc, `originalName`)}
                                </a>
                                <a
                                  onClick={() => removeFile(`assessmentFiles`, index)}
                                  style={{ marginRight: 8, marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                                >
                                  <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                                </a>
                                {index < _.get(values, `assessmentFiles`).length - 1 ? ',' : ''}
                              </span>
                            ))) || `Or drop file here`}
                        </BSForm.Label>
                      </BSForm.Group>
                    </div>
                  </Row>
                </Card.Body>
              </Card>

            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default CandidateEducationDetailsForm;